import Label from './Label';

export const validatorComponent = {
  inject: ['parentValidator'],
  components: {
    Label
  },
  data: function () {
    return {
      val: undefined
    };
  },
  computed: {
    getLabel () {
      return this.label;
    }
  },
  watch: {
    val () {
      this.$emit('input', this.val);
    }
  },
  props: {
    info: String,
    value: {
      required: true
    },
    required: {
      type: Boolean,
      default: true
    },
    label: {
      type: String,
      required: true
    }
  },
  created () {
    this.$validator = this.parentValidator;
    this.val = this.value;
  }
};
